// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module__footer___3qD_B"};